



// used in client side

const clientUserAgent = typeof (navigator) !== 'undefined' ? navigator.userAgent : null

export function isMobile(ua?: string) {

    const userAgent = ua || clientUserAgent;
    if (!userAgent) {
        return false;
    }
    return /Android/i.test(userAgent) ||
        /BlackBerry/i.test(userAgent) ||
        /iPhone|iPad|iPod/i.test(userAgent) ||
        /IEMobile/i.test(userAgent)
}

export function isWeChat(ua?: string) {

    const userAgent = ua || clientUserAgent;
    if (!userAgent) {
        return false;
    }
    return /MicroMessenger/i.test(userAgent) && !(/wxwork/i.test(userAgent));
}


export function isWxWork(ua?: string) {

    const userAgent = ua || clientUserAgent;
    if (!userAgent) {
        return false;
    }
    return /MicroMessenger/i.test(userAgent) && (/wxwork/i.test(userAgent));
}


export function isIOS(ua?: string) {

    const userAgent = ua || clientUserAgent;
    if (!userAgent) {
        return false;
    }
    return /iPhone|iPad|iPod/i.test(userAgent)
}

